export const COUNTRY_OK = 'country_ok';
export const setCountry = (country) => ({ type: COUNTRY_OK, country });
